import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import Button from '../Button';
import colours from '../Colours';
import Icon from '../Icons/Icon';
import axios from "axios";
import { P3Bold, P4 } from '../Text';
import moment from 'moment';
import { InLineLoading } from '../../Loading_Icon';

const DamageStatusCard = (props) => {
    const [hasDamage, setHasDamage] = useState(false);
    const [report, setReport] = useState({});
    const [damageDesc, setDamageDesc] = useState([]);
    const [iconContainerStyle, setIconContainerStyle] = useState({});

    const addDamagesDescription = (damages = []) => damages.map(damage => {
        if (damage.active == 1 && damage.type == 0){
            let str = '';

            if (damage.cr_part_damage_type?.length) {
                damage.cr_part_damage_type.map((damage_type, index)=> {
                    str += (damage_type.name);

                    if (index + 1 < damage.cr_part_damage_type.length) {
                        str += (', ');
                    }
                })
            }

            str += (' - ' + damage.name);

            if (!damageDesc.includes(str)) {
                setDamageDesc(prev => [...prev, str]);
            }
        }
    });

    useEffect(() => {
        const { latestReport } = props;
        const isDamage = latestReport?.damage;

        setReport(latestReport);
        setIconContainerStyle({ borderRadius: '8px', border: `solid 1px ${isDamage ? colours.accent.error_red : colours.accent.validate_green}`});

        if (isDamage) {
            setHasDamage(true);

            if (latestReport.exterior_damages?.length) {
                addDamagesDescription(latestReport.exterior_damages);
            }

            if (latestReport.interior_damages?.length) {
                addDamagesDescription(latestReport.interior_damages);
            }
        }
    }, [props.latestReport]);

    const openReport = () => {
        if (report.pdf_link) {
            window.open(report.pdf_link, '_blank');
        }
        else {
            axios.get('/ajax/vehicle/' + props.vehicle_details.vehicle.V_ID + '/ride_reports/' + report.id)
                .then(function(response) {
                    showStatusMsg("PDF Report hasn't been generated for this RideReport, it will be emailed to you once it has been generated. If you are experiencing this problem for a longer time, please contact the support team.", 'success');
                })
                .catch(function(error) {
                    showStatusMsg("There is an issue generating this RideReport, please contact the support team.");
                });
        }
    }

    return (
        <div className={hasDamage ? "ds-statuscard-container-red" : "ds-statuscard-container-green"}>
            <div className={`ds-statuscard-header ${hasDamage ? 'ds-statuscard-header-red' : 'ds-statuscard-header-green'}`}>
                <P3Bold style={{color: colours.primary.white}}>{hasDamage ? 'DAMAGE' : 'RideReport'}</P3Bold>
            </div>
            <div className="ds-statuscard-content">
                <div className="ds-statuscard-content-row mt-4">
                    <div className="ds-statuscard-icon">
                        <Icon name={(hasDamage ? "Damage" : "Check")} size={24} style={iconContainerStyle}/>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column', flex: 1}}>
                        <div className="ds-statuscard-content-row-space-between">
                            <P3Bold>{hasDamage ? "Last Update" : "No Damage Reported"}</P3Bold>
                            {hasDamage && <P3Bold>{moment(report.report_date).format('MMM DD, YYYY')}</P3Bold>}
                        </div>
                        {hasDamage && damageDesc?.length > 0 &&
                            damageDesc.map((desc) => (
                                <P4 key={desc} style={{color: colours.primary.grey02}}>
                                    {desc}
                                </P4>
                            ))
                        }
                    </div>
                </div>
                {hasDamage ? (
                    <div className="ds-statuscard-button-row">
                        <Button secondary small label="View Report" onClick={openReport}/>
                        <Button tertiary small label="View All Reports" onClick={()=> {props.setTab('RideReports')}}/>
                    </div>
                ) : (
                    <div>
                        <div className="ds-statuscard-content-row-space-between mt-8">
                            <P3Bold>Last Report</P3Bold>
                            <P3Bold>{moment(report.report_date).format('MMM DD, YYYY')}</P3Bold>
                        </div>
                        <div className="ds-statuscard-button-row">
                            <Button secondary small label="View Last Report" onClick={openReport}/>
                            <Button tertiary small label="View All Reports" onClick={()=> {props.setTab('RideReports')}}/>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    stakeholder: store.stakeholder,
    settings: store.settings,
    data: store.data
})

export default connect(mapStateToProps)(DamageStatusCard);